import { useState } from 'react';

const ProductGallery = () => {
  const [selectedImage, setSelectedImage] = useState(0);

  const images = [
    'https://public.readdy.ai/ai/img_res/bfccd2872b2465f6aa963419531a8b4e.jpg',
    'https://readdy.ai/api/search-image?query=mechanical%20gaming%20keyboard%20side%20angle%20view%20showing%20keycap%20profile%20and%20RGB%20lighting%20effects%2C%20premium%20build%20quality%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=peripherals-side-002&orientation=squarish',
    'https://readdy.ai/api/search-image?query=close%20up%20detail%20of%20mechanical%20keyboard%20switches%20and%20keycaps%2C%20RGB%20backlight%20glowing%2C%20premium%20quality%20construction%2C%20white%20background%2C%20macro%20photography&width=600&height=600&seq=peripherals-detail-003&orientation=squarish',
    'https://readdy.ai/api/search-image?query=mechanical%20keyboard%20with%20USB%20cable%20connection%20detail%2C%20premium%20braided%20cable%2C%20clean%20white%20background%2C%20professional%20product%20photography&width=600&height=600&seq=peripherals-cable-004&orientation=squarish'
  ];

  return (
    <div className="w-full">
      <div className="w-full h-[500px] bg-white rounded-lg mb-4 overflow-hidden border border-gray-200">
        <img
          src={images[selectedImage]}
          alt="제품 이미지"
          className="w-full h-full object-contain"
        />
      </div>
      <div className="grid grid-cols-4 gap-3">
        {images.map((image, index) => (
          <button
            key={index}
            onClick={() => setSelectedImage(index)}
            className={`w-full h-24 bg-white rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${
              selectedImage === index ? 'border-teal-500' : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <img
              src={image}
              alt={`썸네일 ${index + 1}`}
              className="w-full h-full object-contain"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductGallery;